/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box, Button, Divider, Icon, MenuItem, Menu, Paper, Skeleton, 
  Theme, Typography, useMediaQuery, useTheme, Fade, alpha
} from '@mui/material';
import { useState } from 'react';

interface IFerramentasDeDetalheProps {
  textoBotaoNovo?: string;
  textoBotaoCartaoPonto?: string;
  textoBotaoCartaoPontoVerso?: string;

  mostrarBotaoNovo?: boolean;
  mostrarBotaoVoltar?: boolean;
  mostrarBotaoApagar?: boolean;
  mostrarBotaoSalvar?: boolean;
  mostrarBotaoSalvarEFechar?: boolean;
  mostrarBotaoImpressao?: boolean;
  disableBotaoApagar?: boolean;
  disableBotaoSalvar?: boolean;
  mostrarBotaoNovoCarregando?: boolean;
  mostrarBotaoVoltarCarregando?: boolean;
  mostrarBotaoApagarCarregando?: boolean;
  mostrarBotaoSalvarCarregando?: boolean;
  mostrarBotaoSalvarEFecharCarregando?: boolean;
  mostrarBotaoImpressaoCarregando?: boolean;
  mostrarBotaoHistorico?: boolean;
  mostrarBotaoHistoricoCarregando?: boolean;
  mostrarBotaoferais?: boolean;
  mostrarBotaoferaisCarregando?: boolean; 
  mostrarBotaoauxilio?: boolean;
  mostrarBotaoauxilioCarregando?: boolean;

  mostrarBotaoCartaoPonto?: boolean;
  mostrarBotaoCartaoPontoCarregando?: boolean;
  aoClicarEmCartaoPonto?: () => void;

  mostrarBotaoCartaoPontoVerso?: boolean;
  mostrarBotaoCartaoPontoVersoCarregando?: boolean;
  aoClicarEmCartaoPontoVerso?: () => void;

  aoClicarEmNovo?: () => void;
  aoClicarEmVoltar?: () => void;
  aoClicarEmApagar?: () => void;
  aoClicarEmSalvar?: () => void;
  aoClicarEmSalvarEFechar?: () => void;
  aoClicarEmImpressao?: () => void;
  aoClicarEmHistorico?: () => void;
  aoClicarEmFerias?: () => void;
  aoClicarEmFeriasAdd?: () => void;
  aoClicarEmAuxilio?: () => void;
  aoClicarEmAuxilioAdd?: () => void;
}

export const FerramentasDeDetalhe: React.FC<IFerramentasDeDetalheProps> = ({
  textoBotaoNovo = 'Novo',
  textoBotaoCartaoPonto = 'Cartão de Ponto Frente',
  textoBotaoCartaoPontoVerso = 'Cartão de Ponto Verso',

  mostrarBotaoCartaoPonto = false,
  mostrarBotaoCartaoPontoVerso = false,

  mostrarBotaoNovo = true,
  mostrarBotaoVoltar = true,
  mostrarBotaoApagar = true,
  mostrarBotaoSalvar = true,
  mostrarBotaoSalvarEFechar = false,
  mostrarBotaoImpressao = true,
  mostrarBotaoHistorico = false,
  mostrarBotaoferais = false,
  mostrarBotaoauxilio = false,

  mostrarBotaoCartaoPontoCarregando = false,
  mostrarBotaoCartaoPontoVersoCarregando = false,

  mostrarBotaoNovoCarregando = false,
  mostrarBotaoVoltarCarregando = false,
  mostrarBotaoApagarCarregando = false,
  mostrarBotaoSalvarCarregando = false,
  mostrarBotaoSalvarEFecharCarregando = false,
  mostrarBotaoImpressaoCarregando = false,
  disableBotaoApagar = false,
  disableBotaoSalvar = false,
  mostrarBotaoHistoricoCarregando = false,
  mostrarBotaoferaisCarregando = false,
  mostrarBotaoauxilioCarregando = false,

  aoClicarEmCartaoPonto,
  aoClicarEmCartaoPontoVerso,
  aoClicarEmNovo,
  aoClicarEmVoltar,
  aoClicarEmApagar,
  aoClicarEmSalvar,
  aoClicarEmSalvarEFechar,
  aoClicarEmImpressao,
  aoClicarEmHistorico,
  aoClicarEmFerias,
  aoClicarEmFeriasAdd,
  aoClicarEmAuxilio,
  aoClicarEmAuxilioAdd,
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElAuxilio, setAnchorElAuxilio] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const opena = Boolean(anchorElAuxilio);
  
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleClickAuxilio = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElAuxilio(event.currentTarget);
  };
  
  const handleCloseAuxilio = () => {
    setAnchorElAuxilio(null);
  };

  const handleFeriasClick = () => {
    if (aoClicarEmFerias) {
      aoClicarEmFerias();
    }
    handleClose();
  };

  const handleFeriasAddClick = () => {
    if (aoClicarEmFeriasAdd) {
      aoClicarEmFeriasAdd();
    }
    handleClose();
  };

  const handleAuxilioAddClick = () => {
    if (aoClicarEmAuxilioAdd) {
      aoClicarEmAuxilioAdd();
    }
    handleCloseAuxilio();
  };

  const handleAuxilioClick = () => {
    if (aoClicarEmAuxilio) {
      aoClicarEmAuxilio();
    }
    handleCloseAuxilio();
  };

  return (
    <Box
      gap={1}
      marginLeft={2}
      marginRight={3.5}
      padding={1}
      paddingX={2}
      display="flex"
      alignItems="center"
      height={theme.spacing(6)}
      component={Paper}
      sx={{
        backgroundColor: alpha(theme.palette.background.paper, 0.95),
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        boxShadow: theme.shadows[1],
        borderRadius: 2,
      }}
    >
      {/* Botão Voltar */}
      {(mostrarBotaoVoltar && !mostrarBotaoVoltarCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmVoltar}
          startIcon={<Icon>arrow_back</Icon>}
          sx={{
            fontWeight: 'bold',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              transform: 'translateY(-1px)',
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Voltar
          </Typography>
        </Button>
      )}

      {mostrarBotaoVoltarCarregando && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Divisor após Voltar */}
      {mostrarBotaoVoltar && (
        <Divider variant='middle' orientation='vertical' flexItem sx={{ mx: 1 }} />
      )}

      {/* Botão Salvar */}
      {(mostrarBotaoSalvar && !mostrarBotaoSalvarCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='contained'
          disabled={disableBotaoSalvar}
          onClick={aoClicarEmSalvar}
          startIcon={<Icon>save</Icon>}
          sx={{
            background: `linear-gradient(45deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
            fontWeight: 'bold',
            '&:hover': {
              background: `linear-gradient(45deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
              transform: 'translateY(-1px)',
              boxShadow: theme.shadows[4],
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Salvar
          </Typography>
        </Button>
      )}

      {mostrarBotaoSalvarCarregando && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Botão Salvar e Fechar (apenas em telas maiores) */}
      {(mostrarBotaoSalvarEFechar && !mostrarBotaoSalvarEFecharCarregando && !smDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          disabled={disableBotaoSalvar}
          onClick={aoClicarEmSalvarEFechar}
          startIcon={<Icon>save</Icon>}
          sx={{
            fontWeight: 'bold',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              transform: 'translateY(-1px)',
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Referências
          </Typography>
        </Button>
      )}

      {(mostrarBotaoSalvarEFecharCarregando && !smDown) && (
        <Skeleton width={180} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Botão Apagar */}
      {(mostrarBotaoApagar && !mostrarBotaoApagarCarregando) && (
        <Button
          color='error'
          disableElevation
          variant='contained'
          disabled={disableBotaoApagar}
          onClick={aoClicarEmApagar}
          startIcon={<Icon>delete</Icon>}
          sx={{
            background: `linear-gradient(45deg, ${theme.palette.error.main} 0%, ${theme.palette.error.dark} 100%)`,
            fontWeight: 'bold',
            '&:hover': {
              background: `linear-gradient(45deg, ${theme.palette.error.dark} 0%, ${theme.palette.error.main} 100%)`,
              transform: 'translateY(-1px)',
              boxShadow: theme.shadows[4],
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Apagar
          </Typography>
        </Button>
      )}

      {mostrarBotaoApagarCarregando && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Divisor entre ações principais e secundárias */}
      {(mostrarBotaoNovo || mostrarBotaoCartaoPonto || mostrarBotaoCartaoPontoVerso || 
        mostrarBotaoImpressao || mostrarBotaoHistorico || mostrarBotaoferais || mostrarBotaoauxilio) && (
        <Divider variant='middle' orientation='vertical' flexItem sx={{ mx: 1 }} />
      )}

      {/* Botão Novo */}
      {(mostrarBotaoNovo && !mostrarBotaoNovoCarregando && !smDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmNovo}
          startIcon={<Icon>add</Icon>}
          sx={{
            fontWeight: 'bold',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              transform: 'translateY(-1px)',
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {textoBotaoNovo}
          </Typography>
        </Button>
      )}

      {(mostrarBotaoNovoCarregando && !smDown) && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Botão Cartão de Ponto */}
      {(mostrarBotaoCartaoPonto && !mostrarBotaoCartaoPontoCarregando && !smDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmCartaoPonto}
          startIcon={<Icon>credit_card</Icon>}
          sx={{
            fontWeight: 'bold',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              transform: 'translateY(-1px)',
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {textoBotaoCartaoPonto}
          </Typography>
        </Button>
      )}

      {(mostrarBotaoCartaoPontoCarregando && !smDown) && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Botão Cartão de Ponto Verso */}
      {(mostrarBotaoCartaoPontoVerso && !mostrarBotaoCartaoPontoVersoCarregando && !smDown) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmCartaoPontoVerso}
          startIcon={<Icon>credit_card</Icon>}
          sx={{
            fontWeight: 'bold',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              transform: 'translateY(-1px)',
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            {textoBotaoCartaoPontoVerso}
          </Typography>
        </Button>
      )}

      {(mostrarBotaoCartaoPontoVersoCarregando && !smDown) && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Botão Imprimir */}
      {(mostrarBotaoImpressao && !mostrarBotaoImpressaoCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmImpressao}
          startIcon={<Icon>print</Icon>}
          sx={{
            fontWeight: 'bold',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              transform: 'translateY(-1px)',
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Imprimir
          </Typography>
        </Button>
      )}

      {mostrarBotaoImpressaoCarregando && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Botão Histórico */}
      {(mostrarBotaoHistorico && !mostrarBotaoHistoricoCarregando) && (
        <Button
          color='primary'
          disableElevation
          variant='outlined'
          onClick={aoClicarEmHistorico}
          startIcon={<Icon>history</Icon>}
          sx={{
            fontWeight: 'bold',
            borderColor: alpha(theme.palette.primary.main, 0.5),
            color: theme.palette.primary.main,
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
              transform: 'translateY(-1px)',
            }
          }}
        >
          <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
            Histórico de Salário
          </Typography>
        </Button>
      )}

      {mostrarBotaoHistoricoCarregando && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Menu de Férias */}
      {(mostrarBotaoferais && !mostrarBotaoferaisCarregando) && (
        <Box>
          <Button
            id="fade-button-ferias"
            aria-controls={open ? 'fade-menu-ferias' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            color='primary'
            disableElevation
            variant='outlined'
            onClick={handleClick}
            startIcon={<Icon>beach_access</Icon>}
            sx={{
              fontWeight: 'bold',
              borderColor: alpha(theme.palette.primary.main, 0.5),
              color: theme.palette.primary.main,
              '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: alpha(theme.palette.primary.main, 0.08),
                transform: 'translateY(-1px)',
              }
            }}
          >
            <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
              Férias
            </Typography>
          </Button>
          <Menu
            id="fade-menu-ferias"
            MenuListProps={{
              'aria-labelledby': 'fade-button-ferias',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem onClick={handleFeriasClick}>Listagem</MenuItem>
            <MenuItem onClick={handleFeriasAddClick}>Adicionar</MenuItem>
          </Menu>
        </Box>
      )}

      {mostrarBotaoferaisCarregando && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}

      {/* Menu de Auxílio */}
      {(mostrarBotaoauxilio && !mostrarBotaoauxilioCarregando) && (
        <Box>
          <Button
            id="fade-button-auxilio"
            aria-controls={opena ? 'fade-menu-auxilio' : undefined}
            aria-haspopup="true"
            aria-expanded={opena ? 'true' : undefined}
            color='primary'
            disableElevation
            variant='outlined'
            onClick={handleClickAuxilio}
            startIcon={<Icon>support</Icon>}
            sx={{
              fontWeight: 'bold',
              borderColor: alpha(theme.palette.primary.main, 0.5),
              color: theme.palette.primary.main,
              '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: alpha(theme.palette.primary.main, 0.08),
                transform: 'translateY(-1px)',
              }
            }}
          >
            <Typography variant='button' whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
              Auxílio
            </Typography>
          </Button>
          <Menu
            id="fade-menu-auxilio"
            MenuListProps={{
              'aria-labelledby': 'fade-button-auxilio',
            }}
            anchorEl={anchorElAuxilio}
            open={opena}
            onClose={handleCloseAuxilio}
            TransitionComponent={Fade}
          >
            <MenuItem onClick={handleAuxilioClick}>Listagem</MenuItem>
            <MenuItem onClick={handleAuxilioAddClick}>Adicionar</MenuItem>
          </Menu>
        </Box>
      )}

      {mostrarBotaoauxilioCarregando && (
        <Skeleton width={110} height={36} sx={{ borderRadius: 1 }} />
      )}
    </Box>
  );
};